import { apiClient } from './apiClient';

export interface FileUploadResponse {
  success: boolean;
  fileName?: string;
  originalName?: string;
  size?: number;
  contentType?: string;
  error?: string;
}

export interface FileDeleteResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export const fileService = {
  // Загрузка файла
  async uploadFile(file: File): Promise<FileUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post('/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  // Загрузка логотипа компании
  async uploadCompanyLogo(companyId: string, file: File): Promise<FileUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(`/companies/${companyId}/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  // Удаление логотипа компании
  async deleteCompanyLogo(companyId: string): Promise<FileDeleteResponse> {
    const response = await apiClient.delete(`/companies/${companyId}/logo`);
    return response.data;
  },

  // Получение URL файла
  getFileUrl(fileName: string): string {
    return `${apiClient.defaults.baseURL}/files/${fileName}`;
  },

  // Получение URL логотипа компании
  getCompanyLogoUrl(logoPath: string): string {
    if (!logoPath) return '';
    // Формируем полный URL для получения файла
    const baseURL = apiClient.defaults.baseURL || '/api';
    const url = `${baseURL}/files/${logoPath}`;
    console.log('getCompanyLogoUrl:', { logoPath, baseURL, url });
    return url;
  },

  // Валидация файла
  validateFile(file: File, maxSize: number = 2 * 1024 * 1024): { valid: boolean; error?: string } {
    // Проверка размера
    if (file.size > maxSize) {
      return {
        valid: false,
        error: `Размер файла не должен превышать ${Math.round(maxSize / 1024 / 1024)}MB`
      };
    }

    // Проверка типа файла
    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
    if (!allowedTypes.includes(file.type)) {
      return {
        valid: false,
        error: 'Неподдерживаемый тип файла. Разрешены: PNG, JPG, JPEG, SVG'
      };
    }

    return { valid: true };
  }
};
